<template>
    <div class="container">
        <div class="row">
            <div class="evaluate">
                <h1 class="title">{{(company&&company._id?(evaluate.alias?evaluate.alias:evaluate.name):evaluate.name)+(company&&company._id?('-'+company.name):'')}}</h1>
                <div class="infos">
                    <span class="item">{{evaluate.evaluate_num}}人测试过</span>
                    <span class="item hidden-xs">{{evaluate.create_at|format}}发布</span>
                    <span class="item right">本次测试共
                        <span class="num">{{evaluate.questions_num}}</span>题</span>
                </div>
                <div class="desc" v-html="evaluate.desc">
                </div>
                <div class="timer m-t-b-sm" v-if="evaluate.duration != -1">
                    本次测评限时
                    <span class="num">{{evaluate.duration/60}}</span>分钟，超时后将自动结束测评。
                </div>
                <div class="actions m-t-sm">
                    <router-link type="button" :to="{'name':'/auth/initialize',params:{code:code}, query:user }" v-if="is_initialize === -1" class="btn btn-sm btn-primary" :disabled="is_processing === 1" tag="button">用户初始化</router-link>
                    <button type="button" @click="login" v-if="is_login === -1 && is_initialize !== -1" class="btn btn-sm btn-primary" :disabled="is_processing === 1">用户登录</button>
                    <button type="button" @click="report" v-if="is_login === 1  && finish.status > 1" class="btn btn-sm btn-success" :disabled="is_processing === 1">查看报告</button>
                    <button type="button" @click="startEvaluate" class="btn btn-sm btn-success" v-if="is_login === 1  && finish.status === 0" :disabled="is_processing == 1">开始测评</button>
                    <button type="button" @click="startEvaluate" class="btn btn-sm btn-success" v-if="is_login === 1  && finish.status === 1" :disabled="is_processing == 1">继续测评</button>
                </div>
                <div class="row">
                    <h5 class="text-center m-t-b-sm">本次测评由
                        <a href="http://www.psych.cas.cn" title="中国科学院心理研究所" alt="中国科学院心理研究所" style="color:#000">中国科学院心理研究所</a> 提供测评技术支持</h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../resource/evaluate";

export default {
  name: "EvaluateShow",
  data: function() {
    return {
      name: "",
      phone: "",
      is_processing: 1,
      evaluate: {},
      company: {},
      is_login: 0,
      is_initialize: 1,
      user: {},
      type: 1,
      code: "",
      finish: {
        code: "0000000000000000000000",
        status: 0
      }
    };
  },
  created: function() {
    let that = this;
    Evaluate.questionnaire({ code: that.$route.params.code }).then(
      res => {
        let data = res.body;
        if (data.code === 0) {
          that.evaluate = data.result.questionnaire;
          that.company = data.result.company;
          that.is_login = data.result.is_login;
          that.is_initialize = data.result.is_initialize === -1 ? -1 : 1;
          that.user = data.result.user;
          that.type = data.result.category === "questionnaire" ? 1 : 2; // 问卷还是code
          if (that.type === 2) {
            // code
            that.code = that.$route.params.code;
          }
          if (data.result.code) {
            // 完成
            that.finish.code = data.result.code;
            that.finish.status = data.result.status; // code 完成状态
            if (that.type === 1) {
              // 已完成
              that.code = data.result.code;
            }
          } else {
            that.finish.code = "0000000000000000000000";
            that.finish.status = 0;
          }
        } else if (data.code === 4) {
          // 无权限
          that.$router.replace({ name: "EvaluateList" });
        } else {
          // 无权限
          alert(`服务器异常，请稍后再试\n有人要扣工资了~~~~(>_<)~~~~`);
          that.$router.replace({ name: "EvaluateList" });
        }
        that.is_processing = 0;
      },
      res => {
        that.is_processing = 0;
      }
    );
  },
  methods: {
    startEvaluate: function() {
      let that = this;
      if (that.is_processing === 1) {
        alert("系统正在处理，请稍后...");
        return;
      }
      that.is_processing = 1;
      if (that.is_login === 1) {
        // 用户登录
        if (that.code) {
          //
          that.$router.replace(`/evaluate/${that.code}/start`);
        } else {
          //新问卷自动购买
          that
            .$http({
              method: "POST",
              url: `/api/v1/evaluate/${that.$route.params.code}`
            })
            .then(res => {
              let data = res.body;
              if (data.code === 0) {
                that.code = data.result;
                that.$router.replace(`/evaluate/${that.code}/start`);
              } else {
                alert(data.msg);
              }
            });
        }
      } else {
        // 未登录
        that.login();
      }
    },
    login: function() {
      let that = this;
      that.$router.replace({
        name: "/auth/login",
        query: {
          refer: that.$route.fullPath,
          username: that.user ? that.user.email : ""
        }
      });
    },
    report: function() {
      let that = this;
      if (that.is_processing === 1) {
        alert("系统正在处理，请稍后...");
        return;
      }
      that.is_processing = 1;
      if (that.code !== that.finish.code) {
        // 复制数据
        that
          .$http({
            method: "PUT",
            url: `/api/v1/evaluate/copy_evaluate`,
            body: {
              used_code: that.finish.code,
              unused_code: that.code
            }
          })
          .then(res => {
            let data = res.body;
            if (data.code === 0) {
              that.$router.push(`/evaluate/${that.code}/report`);
            } else {
              alert(data.msg);
            }
          });
      } else {
        that.$router.push({
          name: "EvaluateReport",
          params: {
            code: that.code
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped></style>


// WEBPACK FOOTER //
// show.vue?6daf9cc0